import React from 'react';

import './DocumentOption.css';


const NAME_MAP = {
  offeringDocuments: 'Offering Documents',
  offeringSummary: 'Offering Summary',
  riskFactors: 'Risk Factors',
  subscriptionAgreement: 'Subscription Agreement',
};


const Component = ({ location, name }) => (
  <a
    href={location}
    styleName="disclaimerDoc"
    target="_blank"
  >
    { NAME_MAP[name] }
  </a>
);

Component.dispalyName = 'DocumentOptions';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Invest/components/DocumentOption.js